import { use } from 'react';

import { SDSContext } from '@repo/sds/providers/SDSProvider/context';
import type { SDSContextValue, SDSLocationAPI, SDSNavigationAPI } from '@repo/sds/providers/SDSProvider/types';

/**
 * Hook to access SDS configuration
 * Returns the configured link component from SDSProvider, or default anchor tag
 */
export function useSDSConfig(): SDSContextValue {
  return use(SDSContext);
}

/**
 * Hook to access navigation API
 * Returns navigate, replace, and back functions configured for the current framework
 *
 * @example
 * ```tsx
 * const { navigate, replace, back } = useNavigation();
 *
 * const handleClick = () => {
 *   navigate('/dashboard');
 * };
 * ```
 */
export function useNavigation(): SDSNavigationAPI {
  const { navigation } = use(SDSContext);
  return navigation;
}

export function useLocation(): SDSLocationAPI {
  const { location } = use(SDSContext);
  return location;
}
